import {
  SecurityFeatureActionType,
  IReceiveSecurityFeatureAction,
  IReceiveSecurityFeatureErrorAction,
  IRequestSecurityFeatureAction,
  IResetSecurityFeatureAction,
  FeatureFlagListActionType,
  IReceiveFeatureFlagListAction,
  IReceiveFeatureFlagListErrorAction,
  IRequestFeatureFlagListAction,
  IResetFeatureFlagListAction,
} from './action-types';

export function requestSecurityFeature(featureName: any): IRequestSecurityFeatureAction {
  return {
    type: SecurityFeatureActionType.REQUEST_SECURITY_FEATURE,
    featureName: featureName,
  };
}
export function receiveSecurityFeature(data: any): IReceiveSecurityFeatureAction {
  return {
    type: SecurityFeatureActionType.RECEIVE_SECURITY_FEATURE,
    data: data,
  };
}

export function receiveSecurityFeatureError(errorMessage: string): IReceiveSecurityFeatureErrorAction {
  return {
    type: SecurityFeatureActionType.RECEIVE_SECURITY_FEATURE_ERROR,
    errorMessage,
  };
}

export function resetSecurityFeature(): IResetSecurityFeatureAction {
  return {
    type: SecurityFeatureActionType.RESET_SECURITY_FEATURE,
  };
}

// Feature Flag List - GetFeatureNamesAsync
export function requestFeatureFlagList(): IRequestFeatureFlagListAction {
  return {
    type: FeatureFlagListActionType.REQUEST_FEATURE_FLAG_LIST,
  };
}

export function receiveFeatureFlagList(data: any): IReceiveFeatureFlagListAction {
  return {
    type: FeatureFlagListActionType.RECEIVE_FEATURE_FLAG_LIST,
    data: data,
  };
}

export function receiveFeatureFlagListError(errorMessage: string): IReceiveFeatureFlagListErrorAction {
  return {
    type: FeatureFlagListActionType.RECEIVE_FEATURE_FLAG_LIST_ERROR,
    errorMessage,
  };
}

export function resetFeatureFlagList(): IResetFeatureFlagListAction {
  return {
    type: FeatureFlagListActionType.RESET_FEATURE_FLAG_LIST,
  };
}
